import React from 'react'
import {  Col, Container, Row } from 'react-bootstrap'
import '../Indusries/Industies.css'
import Marquee from 'react-fast-marquee'
import { Carousel } from '@mantine/carousel';
import { useRef } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import { Link } from "react-router-dom";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Button } from "@mantine/core";


export const AerospaceDefence = () => {
  const autoplay = useRef(Autoplay({ delay: 2000 }));
    return (
        <div>
            <section className='about-pilog oil-and-gas'>
                <Container>
                    <Row className='align-items-center'>
                        <Col lg={6} className='about-ilog-left oil-and-gas-left'>

                            <h5 className='rise-with-sap'>Aerospace and Defence</h5>
                            <h1>Slash O&M and Inventory Expenses by up to 25%</h1>
                            <p>
                            One data error can delay missions, inflate costs, or compromise safety. Our Data Quality & Governance Suite turns fragmented, unreliable data into a strategic asset,  fueling higher uptime, faster decisions, and leaner operations.
                            </p>
                        </Col>
                        <Col lg={6}>
                            <img className='' style={{ width: '100%' }} src={require("../Assets/industries&company/industries/oil-and-gas-industry-banner-image.png")} alt="" />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='industry-clients'>
                <div>
                    <h2>Trusted by Industry Pioneers</h2>
                    <p style={{ fontSize: '1.1rem' }}>A legacy of excellence, globally recognized and trusted by top organizations worldwide</p>
                </div>
                <div>
                    {/* <Marquee speed={50} delay={0}>
                        <img style={{ width: '20%' }} src="https://piloggroup.com/img/Client%20Logos/Aeronautical-Defence/Client-Logos-10.jpg" alt='' />
                        <img style={{ width: '20%' }} src="https://piloggroup.com/img/Client%20Logos/Aeronautical-Defence/Client-Logos-12.jpg" alt='' />
                        <img style={{width: '10%'}} src="https://piloggroup.com/img/Client%20Logos/recent-logos/Dubai-airports.png" alt=''/>
                        <img style={{ width: '50%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Cairn.png" alt='' />
                        <img style={{ width: '50%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/CCED.png" alt='' />
                        <img style={{ width: '70%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/KJO-new.jpg" alt='' />
                        <img style={{ width: '70%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Noble-Energy.png" alt='' />
                        <img style={{ width: '70%' }} src="https://piloggroup.com/img/Client%20Logos/recent-logos/Draon-oil.jpg" alt='' />
                        <img style={{ width: '70%' }} src="https://piloggroup.com/img/Client%20Logos/recent-logos/OQ.jpg" alt='' />
                        <img style={{ width: '70%' }} src="https://piloggroup.com/img/Client%20Logos/recent-logos/Motiva-logo.jpg" alt='' />
                        <img style={{ width: '70%' }} src="https://piloggroup.com/img/Client%20Logos/recent-logos/bapco-energies-logo.jpg" alt='' />
                        <img style={{ width: '70%' }} src="https://www.piloggroup.com/img/Client%20Logos/Chemicals-Refineries/Aramco.png" alt='' />
                        <img style={{ width: '70%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Chevron.png" alt='' />
                        <img style={{ width: '70%' }} src="https://piloggroup.com/img/Client%20Logos/Chemicals-Refineries/HZL.jpg" alt='' />

                    </Marquee> */}

                    <div className='d-flex gap-5 justify-content-center align-items-center my-3'>
                    <img style={{ width: '10%' }} src="https://piloggroup.com/img/Client%20Logos/Aeronautical-Defence/Client-Logos-10.jpg" alt='' />
                        <img style={{ width: '10%' }} src="https://piloggroup.com/img/Client%20Logos/Aeronautical-Defence/Client-Logos-12.jpg" alt='' />
                        <img style={{width: '10%'}} src="https://piloggroup.com/img/Client%20Logos/recent-logos/Dubai-airports.png" alt=''/>
                        <img style={{ width: '10%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Cairn.png" alt='' />
                        <img style={{ width: '10%' }} src="https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/CCED.png" alt='' />
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                        <Link to=''>
                            <button className='partner-btn'>
                                Read More
                            </button>
                        </Link>
                    </div>
                </div>
            </section>

            

            <section className='data-migration-sap'>
                <Container>
                    <Row className='d-flex justify-content-center align-items-center'>
                        <Col lg={6}>
                            <img className='w-100' src={require("../Assets/industries&company/industries/Key-Pain-Points-for-Oil-&-Gas-CEOs2.png")} alt="" />

                        </Col>

                        <Col lg={6} className='' style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <h2 style={{ fontSize: '2.4rem' }}>Key Data Challenges Impacting Aerospace & Defense</h2>
                            {/* <p>
                                Let our structured, efficient, and secure migration approach to tackle the biggest data challenges in Oil & Gas. Our end-to-end migration process ensures accuracy, compliance, and zero disruptions, enabling a seamless transition while addressing
                            </p> */}
                            <div>

                                <p className='my-1'>✦ Lack of quality, governance & standardization for Asset & MRO data</p>
                                <p className='my-1'>✦ Insufficient asset reliability & integrity in critical equipment tracking.  </p>
                                <p className='my-1'>✦ Customized OEM data for assets & components</p>
                                {/* <p className='my-1'>✦ Regulatory & Compliance Risks</p> */}
                                <p className='my-1'>✦ Unoptimized inventory and compliance risks </p>


                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>

            <section className='data-migration-sap'>
                <Container>
                    <Row className='d-flex justify-content-center align-items-center'>
                       

                        <Col lg={6} className='' style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <h2 style={{ fontSize: '2.4rem' }}>Benefits You Can’t Ignore</h2>
                            {/* <p>
                                Let our structured, efficient, and secure migration approach to tackle the biggest data challenges in Oil & Gas. Our end-to-end migration process ensures accuracy, compliance, and zero disruptions, enabling a seamless transition while addressing
                            </p> */}
                            <div>

                                <p className='my-1'>✦ Unified, Governed & Standardized Asset & MRO Master & Meta Data</p>
                                <p className='my-1'>✦ Standardized Maintenance Strategy, Failure Codes & System Objects</p>
                                <p className='my-1'>✦ Reduced MRO Inventory Costs</p>
                                <p className='my-1'>✦ Inventory Optimization</p>
                                <p className='my-1'>✦ Optimized TCO with Statutory & Regulatory Compliance</p>


                            </div>
                        </Col>

                        <Col lg={6}>
                            <img className='w-100' src={require("../Assets/industries&company/industries/Key-Pain-Points-for-Oil-&-Gas-CEOs2.png")} alt="" />

                        </Col>

                    </Row>
                </Container>
            </section>


            {/* <section>
                <Container className='covered-points-in-industry'>
                    <Row className='d-flex justify-content-center align-items-center'>
                        <Col lg={7} className='covered-points-left'>
                        <h4>From Acquisition to Intelligence, We've Got You Covered!</h4>
                        <Row>
                            <Col lg={6} className='covered-points-left'>
                            <div className='points-covered-industry'>
                            <h5>Acquisition</h5>
                            <h5>Quality Assessment</h5>
                            <h5>Classification </h5>
                            <h5>Harmonization </h5>
                            
                        </div>
                            </Col>
                            <Col lg={6} className='covered-points-right'>
                            <div className='points-covered-industry'>
                           
                            <h5>Acquisition</h5>
                            <h5>Governance</h5>
                            <h5>Analytics</h5>
                        </div>
                            </Col>
                        </Row>
                        
                        </Col>
                        <Col lg={5}>
                        <img className='w-100' src={require("../Assets/industries&company/industries/Key-Pain-Points-for-Oil-&-Gas-CEOs2.png")} alt="" />

                        </Col>
                    </Row>
                </Container>
            </section> */}

            <section>
                <Container className='covered-points-in-industry'>
                    <div className='covered-points-left'>
                    <h4>From Acquisition to Intelligence, We've Got You Covered!</h4>
                    </div>
                    <Row className='d-flex justify-content-center align-items-center'>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                            <h6>Acquisition</h6>
                        </div>
                        </Col>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                        <h6>Quality Assessment</h6>
                        </div>
                        </Col>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                            <h6>Classification </h6>
                        </div>
                        </Col>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                            <h6>Harmonization</h6>
                        </div>
                        </Col>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                            <h6>Migration</h6>
                        </div>
                        </Col>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                            <h6>Governance</h6>
                        </div>
                        </Col>
                        <Col lg={3}>
                        <div className='points-covered-industry'>
                            <h6>Analytics</h6>
                        </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='my-5 py-3'>
                <Container>
                    <div>
                        <h2 style={{ fontSize: '2.4rem', textAlign: 'center' }}>PiLog’s Data Quality & Governance Suite Core Elements</h2>
                    </div>
                    <Row className="d-flex justify-content-center align-items-center">
                        <Col lg={4} md={6} sm={10}>
                            <div className='industry-card'>
                                <img className='' src={require('../Assets/SAP/Pre-Migration Assessment_Icon-01.png')} alt="" />
                                <h4>Simple, Agile, Swift</h4>
                                <p> 
                                Built for ease of use, quick deployment, and flexible integration, ensuring your data projects move faster with minimal complexity.
                                </p>
                            </div>

                        </Col>
                        <Col lg={4} md={6} sm={10}>
                            <div className='industry-card'>
                                <img className='' src={require('../Assets/SAP/Data Cleansing & Preparation_Icon-01.png')} alt="" />

                                <h4>ISO Content & Industry Governance Practices</h4>
                                <p>
                                Our preloaded ISO-compliant data models and global governance standards ensure your data meets regulatory and operational benchmarks.
                                </p>
                            </div>
                        </Col>
                        <Col lg={4} md={6} sm={10}>

                            <div className='industry-card'>
                                <img className='' src={require('../Assets/SAP/Customized Migration Plans_Icon-01.png')} alt="" />

                                <h4>Predefined Rules & Processes</h4>
                                <p>
                                No need to built from scratch. Our solution is embedded with proven business rules and workflows that ensure consistent, high-quality data right from the start.
                                </p>
                            </div>
                        </Col>
                        <Col lg={4} md={6} sm={10}>
                            <div className='industry-card'>
                                <img className='' src={require('../Assets/SAP/Real-Time Monitoring Icon-01.png')} alt="" />

                                <h4>Prebuilt Industry Content Templates</h4>
                                <p>
                                Our industry-specific templates designed for fast adoption and standardization across all industries and business verticals.
                                </p>
                            </div>
                        </Col>
                        <Col lg={4} md={6} sm={10}>
                            <div className='industry-card'>
                                <img className='' src={require('../Assets/SAP/Real-Time Monitoring Icon-01.png')} alt="" />

                                <h4>On SAP Store & BTP Integrated</h4>
                                <p>
                                Certified by SAP and integrated with SAP BTP for seamless data flow across SAP modules like S/4HANA, APM, IBP, MRO, and BNAC.
                                </p>
                            </div>
                        </Col>
                        <Col lg={4} md={6} sm={10}>
                            <div className='industry-card'>
                                <img className='' src={require('../Assets/SAP/Real-Time Monitoring Icon-01.png')} alt="" />

                                <h4>SaaS, PCE & OP</h4>
                                <p>
                                Available on Cloud (SaaS), Private Cloud Edition (PCE), and On-Premise (OP) to support any enterprise IT strategy or deployment model.
                                </p>
                            </div>
                        </Col>
                        
                    </Row>
                </Container>
            </section>

            <section className='industry-leaders-section'>
                <Container>
                    <Row className='justify-content-center align-items-center'>
                        <Col lg={12}>
                            <div class="industry-leaders">
                                <div class="empty-div"></div>
                                <h2>Win Big with PiLog’s DQG Suite!</h2>

                            </div>
                            <div class=" industry-leaders-achivements">
                                <div class="row d-flex justify-content-center align-items-center">

                                    <div class="col-md-12 the-result">

                                        <div class="row d-flex">
                                            <div class="col-md-6 col-sm-10 col-lg-4 results">
                                                <h3>29–34%</h3>
                                                <p>Improved Equipment Availability</p>
                                            </div>
                                            <div class="col-md-6 col-sm-10 col-lg-4 results">
                                                <h3>32–37%</h3>
                                                <p> Reduction in Mean Time to Repair</p>
                                            </div>
                                            <div class="col-md-6 col-sm-10 col-lg-4 results">
                                                <h3>20–25%</h3>
                                                <p>Reduced O&M and Inventory Costs (TCO) </p>
                                            </div>
                                            

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="client-revies-on-industries">
                <Container>
                    <div className="row text-center test-leader-content">
                        <div className="empty-div"></div>
                        <h2>Trusted by Asset-Intensive Operators</h2>

                    </div>
                    <Carousel withIndicators height={300} dragFree loop slideGap="md" align="start"
                        plugins={[autoplay.current]}
                        onMouseEnter={autoplay.current.stop}
                        onMouseLeave={autoplay.current.reset}
                    >
                        <Carousel.Slide className='carousel-inner'>
                            <div className="carousel-item">
                                <div className="quote-icon">❝</div>
                                <div className="stars">★★★★★</div>
                                <p className="quote">With accurate data and complete audit trails, PiLog LDG made regulatory
                                    compliance effortless, minimizing risks and improving reporting transparency!</p>
                                <p className="author">— Gartner®, Hype Cycle for Supply Chain Strategy</p>
                            </div>
                        </Carousel.Slide>
                        <Carousel.Slide className='carousel-inner'>
                        <div className="carousel-item">
                                <div className="quote-icon">❝</div>
                                <div className="stars">★★★★★</div>
                                <p className="quote">We reduced inventory costs by 15% and achieved 100% compliance
                                with PiLog’s scalable framework.</p>
                                <p className="author">— VP of Digital Transformation, Leading Indian Energy Conglomerate</p>
                            </div>
                        </Carousel.Slide>
                        <Carousel.Slide className='carousel-inner'>
                        <div className="carousel-item">
                                <div className="quote-icon">❝</div>
                                <div className="stars">★★★★★</div>
                                <p className="quote">Standardizing 28K+ materials with PiLog’s MDRM system cut
                                procurement costs by 20%.</p>
                                <p className="author">— Head of Procurement, Global Refinery Operator</p>
                            </div>
                        </Carousel.Slide>
                        {/* ...other slides */}
                    </Carousel>

                </Container>
            </section>


            <section className='sap-cta'>
                    <div >
                      <Container className='sap-cta-content'>
                        
                        <h2>From Hangar to Horizon, Govern Your Data Right!</h2>
                        <p>
                        Want to Elevate Your Defense & Aerospace Data with Unmatched Quality & Governance?
                        </p>
                        <Link to="/extended-supply">
                              <Button variant="filled" rightSection={<ArrowOutwardIcon fontSize="20`"/>}>Get Started Today!</Button>
                            </Link>
                       
                       
                      </Container>
                    </div>
                  </section>


        </div>
    )
}
